import { blogSidebar } from '@kkf/design'
import { POSTS } from './blog'

/**
 * Content for the shared `.ul-inner-sidebar`, on the two pages that are not the blog.
 *
 * `/events/:slug` and `/donations/:slug` render the same rail the blog does, and they have
 * no posts of their own to derive it from — so this is the Foundation's blog, dressed as a
 * sidebar. The blog's own two pages no longer read this file: `BlogIndex` and `BlogArticle`
 * derive the rail from the posts they were handed, which is what keeps a four-site blog
 * from showing the Foundation's recent posts on the garage.
 *
 * Derived rather than authored, for the reason it always was: a hand-written recent-posts
 * list is a list of posts that used to exist.
 */
export const INNER_SIDEBAR = blogSidebar(POSTS)
